
// #region Imports
/**
 * axios is used to make https request to fetch data
 */
import axios from 'axios';
/**
 * objToURLParams convert Object to Url with param
 */
import {objToURLParams} from '../utils';
// #endregion

// #region Variable Declaration
/**
 * This action type is triggered when an input value is changed.
 */
export const UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
/**
 * This action type Suggests that a direction request is made.
 */
export const DIRECTIONS_REQUEST = 'DIRECTIONS_REQUEST';
/**
 * This action type Suggests that a direction request is made and respose received successfully.
 */
export const DIRECTIONS_SUCCESS = 'DIRECTIONS_SUCCESS';
/**
 * This action type Suggests that a direction request is made response received with an error.
 */
export const DIRECTIONS_FAILURE = 'DIRECTIONS_FAILURE';
/**
 * This action type is used to indicate Select current trip
 */
export const SELECT_CURRENT_TRIP = 'SELECT_CURRENT_TRIP';
/**
 * This action type is used to indicate Load configuration
 */
export const LOAD_CONFIG = 'LOAD_CONFIG';
/**
 * This action type suggest this action is Print page.
 */
export const PRINT_PAGE='PRINT_PAGE'; //Feature_issue-9 Changes -- Vishal Chauhan
// #endregion


/**
* It is written in actions>>Index .
* Used in Map>>Index and Planner>>Index.
* after excuting this function, controls goes to reducers>>Index>>formReducer
* @param {Object} 'Event Object having control details'
* @return {Object} Control related data
*/
export const updateFormField = event => {
    //fetch target property
    const {target} = event;  
    //stores the control name
    const name = target.name;
    //stores control value.
    //If control is checkbox then store selected checkbox value.
    const value = target.type === 'checkbox' ? target.checked.toString() : target.value;
    //stroes errors array
    const errors = event.error ? [event.error] : [];
    //stores event related params 
    //if there is no param then send empty object
    const params = event.params || {};
    return {
        type: UPDATE_FORM_FIELD,
        payload: {
            name,
            value,
            errors,
            params
        }
    };
};

/**
* Fuction is used to get direction data as per from and To location provided by user. 
* It is written in actions>>Index.
* Used in Map>>Index and Planner>>Index.
* After excuting this function, controls goes to reducers>>Index
* @param {Object} 'Form Object'
* @return {Object} Direction Details or Error
*/
export const fetchDirections = form => (dispatch, getState) => {
    //gets form property objcet in simple form
    const simplifiedForm = mapFormToKeyValuePairs(form);
    //convert object into url
    const queryParams = objToURLParams(simplifiedForm);
    const apiURL = getState().config.otpAPI;
    //create axios object to fetch data
    const openTripPlanner = axios.create({
        baseURL: apiURL,
        headers: {
            'content-type': 'application/json',
            'accept': 'application/json'
        }
    });
    //Contrls goes into reducers>>directionsReducer,viewReducer with payload data
    dispatch({type:DIRECTIONS_REQUEST, payload:simplifiedForm});
    //Change url
    window.history.pushState(null, null, queryParams);

    //make get request with params
    openTripPlanner.get('/', {params: {...simplifiedForm}})
        .then(res => {
            //Contrls goes into reducers>>directionsReducer
            dispatch({type:DIRECTIONS_SUCCESS, payload:res});
        })
        .catch(err => {
            //Contrls goes into reducers>>directionsReducer
            dispatch({type:DIRECTIONS_FAILURE, payload:err});
        });
};

/**
* Fuction converts form object property into simple js object.
* It is written in actions>>Index.
* Used in the fetchDirections function.
* @param {Object} 'Form Object'
* @return {Object} Simplified form key value pair object
*/
function mapFormToKeyValuePairs(form) {
    //stores key value pairs
    const formFields = Object.keys(form).map(fieldName => {
        return { key: fieldName, value: form[fieldName].value };
    });
    const simpleFormObject = formFields.reduce((obj, item) => {
        obj[item.key] = item.value;
        return obj;
    }, {});
    return simpleFormObject;
}

/**
* Used in Direction>>DirectionList
* After excuting this function, controls goes to reducers>>Index>>directionsReducer
* @param {Number} 'Trip Index'
* @return {Object} Action type with Trip Index
*/
export const selectCurrentTrip = tripIndex => {
    return {
        type: SELECT_CURRENT_TRIP,
        payload: tripIndex
    };
};
/**
* Used in App.js
* After excuting this function, controls goes to reducers>>Index>>configReducer
* @param {Object} 'Config'
* @return {Object} Action type with Configuration
*/
export const loadConfig = config => {
    return {
        type: LOAD_CONFIG,
        payload: config
    };
};
